// 页面类型
export const pageType = {
  userCenter: 'user_center', // 用户中心(整个用户中心，不是某个路由)
  ucHome: 'uc_home', // 用户中心首页
  ucYinJiCode: 'uc_yinji_code', // 引继码（生成）
  ucCheckPush: 'uc_check_push', // 推送检测
  serviceprivacy: 'serviceprivacy', // 相关条款
  ucAccountUpgrade: 'uc_account_upgrade', // 账号升级
  ucUserInfo: 'uc_user_info', // 个人资料
  ucBindEmail: 'uc_bind_email', // 绑定邮箱
  ucChangePassword: 'uc_change_password', // 修改密码
  ucSecurityQuestion: 'uc_security_question', // 安全问题
  ucYinjiCodeLogin: 'uc_yinji_code_login', // 引继码（登录）
  ucAccountDelete: 'uc_account_delete' // 账号删除
};

// 弹窗类型
export const popupType = {
  bindPopup: 'bindPopup', // 绑定账号弹窗
  switchAccountPopup: 'switchAccountPopup' //切换账号弹窗
};

// 按钮触发位置
export const locationType = {
  ...pageType,
  ...popupType
};

/**
    页面展示
    key: 页面类型key
*/
export const viewPage = key => {
  window?.passportv2DataLayer?.push({
    eventName: 'view_page',
    eventType: pageType[key] || key || ''
  });
};

/**
    弹窗展示
    popupType: 描述弹窗类型
*/
export const showPopup = ({ key, locationKey }) => {
  window?.passportv2DataLayer?.push({
    eventName: 'show_popup',
    eventType: popupType[key] || key || '',
    eventReason: locationType[locationKey] || locationKey || ''
  });
};

/**
    按钮点击
    btnName: 按钮名称
    reason: 按钮所属模块
*/
export const clickButton = ({ btnName, locationKey, otherParams }) => {
  window?.passportv2DataLayer?.push({
    eventName: 'click_button',
    eventType: btnName || '',
    eventReason: locationType[locationKey] || locationKey || '',
    eventValue: otherParams
  });
};
